(() => {
  'use strict';
  const scope = document.getElementById('MainContent');
  if (!scope || !('IntersectionObserver' in window)) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const selectors = '.section-intro,.quality-intro,.inside-photo,.quality-images,.insert-step,.journey-example>div,.deck-details>div,.story-section>div,.story-integrated-spread,.faq-list>details,.contact-intro,.journeys-welcome .card-art,.journey-v4 .rock-story,.journey-v4 .honey-inner,.journey-v4 .journey-map-section';
  const elements = [...scope.querySelectorAll(selectors)].filter(el => !el.closest('[data-island-guide],dialog,form,[hidden]'));
  let observer;
  const reveal = () => {
    observer?.disconnect();
    elements.forEach(el => el.classList.remove('is-pending'));
    if (motion.matches) return;
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        entry.target.classList.remove('is-pending');
        observer.unobserve(entry.target);
      });
    }, { threshold: .08, rootMargin: '0px 0px -24px 0px' });
    elements.forEach(el => {
      el.classList.add('site-fade');
      if (el.getBoundingClientRect().top < innerHeight || el.classList.contains('is-visible')) el.classList.add('is-visible');
      else { el.classList.add('is-pending'); observer.observe(el); }
    });
  };
  try { reveal(); } catch { elements.forEach(el => el.classList.remove('is-pending')); }
  motion.addEventListener('change', reveal);
  window.addEventListener('pageshow', reveal);
})();
